import React, { memo, useEffect, useState } from "react";
import {
  Card,
  Col,
  Form,
  Row
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import "./index.css";

import { Creators as LoadersActions } from "../../store/ducks/loaders";
import { Creators as DriversActions } from "../../store/ducks/drivers";

import { mergeObject } from "../../utils/Object";
import { isScopes } from "../../services/Auth";

import ClientService from "../../services/Client";
import ClientSchemaReduced from "../../services/Client/SchemaReduced";

import DriverService from "../../services/Driver";

import FilterDriverItem from "../FilterDriverItem";
import SwitchDefault from "../Switch/Default";

const FilterDriver = ({
  props: { currentUser, drivers, driversSearch, driversSearchOnlyClient, driversSearchQueryEnabled },
  funcs: { disableLoader, enableLoader, searchDrivers, setDrivers, setDriversSelected },
  options: { filterMultiple }
}) => {
  const { t } = useTranslation();
  const clientService = new ClientService();
  const driverService = new DriverService();

  const [switchAllChecked, setSwitchAllChecked] = useState(false);
  const [switchSingleChecked, setSwitchSingleChecked] = useState(false);
  const [_driversSelected, _setDriversSelected] = useState([]);

  const [_driversSearch, _setDriversSearch] = useState({
    client: JSON.parse(JSON.stringify(ClientSchemaReduced)),
    word: "",
    active: -1
  });

  const [activeOptions] = useState([
    { value: true, label: t("Active") },
    { value: false, label: t("Inactive") },
    { value: -1, label: t("All") }
  ]);

  const [clientSelectedOption, setClientSelectedOption] = useState(_driversSearch.client.id === "" ? null : {
    dataAux: mergeObject(JSON.parse(JSON.stringify(ClientSchemaReduced)), _driversSearch.client),
    label: _driversSearch.client.type === "LEG" ? _driversSearch.client.legal.socialReason : _driversSearch.client.personal.name,
    value: _driversSearch.client.id
  });

  useEffect(() => {
    findDrivers();
  }, []); /* eslint-disable-line */

  useEffect(() => {
    searchDrivers(_driversSearch);
  }, [_driversSearch]); /* eslint-disable-line */

  useEffect(() => {
    if(!switchSingleChecked) {
      if(switchAllChecked) {
        return _setDriversSelected(driversSearchOnlyClient);
      }
      return _setDriversSelected([]);
    }
    setSwitchSingleChecked(false);
  }, [switchAllChecked]); /* eslint-disable-line */

  useEffect(() => {
    setDriversSelected(_driversSelected);
    if(_driversSelected.length > 0 && (driversSearchOnlyClient.length === _driversSelected.length)) {
      return setSwitchAllChecked(true);
    }
    setSwitchAllChecked(false);
  }, [_driversSelected]); /* eslint-disable-line */

  const clientLoadOptions = (e, c) => {
    clientLoadOptionsDebounce(e, c);
  };

  const clientLoadOptionsDebounce = debounce(async (e, c) => {
    const clients = await clientService.findAutocomplete({ data: {
      search: e
    }, token: currentUser.token });
    c(filterClient(clients));
  }, 1000);

  const filterClient = (clients) => {
    return clients.map(e => {
      return {
        dataAux: e,
        label: e.type === "LEG" ? e.legal.socialReason : e.personal.name,
        value: e.id
      };
    });
  };

  const findDrivers = async () => {
    enableLoader();
    const drivers = await driverService.findAll({
      data: {
        limit: 1000,
        page: 1,
        search: ""
      },
      token: currentUser.token
    });
    setDrivers(drivers.docs);
    disableLoader();
  };

  const handleClickDriver = (e, driver) => {
    if(filterMultiple) {
      return handleClickDriverMultiple(e, driver);
    }
    return handleClickDriverSingle(e, driver);
  };

  const handleClickDriverMultiple = (e, driver) => {
    const driversSelected = _driversSelected.filter(x => x.id !== driver.id);
    if(!e) {
      driversSelected.push(driver);
    }
    setSwitchSingleChecked(true);
    _setDriversSelected(driversSelected);
  };

  const handleClickDriverSingle = (e, driver) => {
    const driversSelected = [driver];
    setSwitchSingleChecked(true);
    _setDriversSelected(driversSelected);
  };

  return (
    <Card>
      <Card.Header>{t("Title.Driver")}</Card.Header>
      <Card.Body>
        <Row>
          {
            isScopes({ currentUser, scopes: [
              "is:master",
              "read:drivers:all"
            ], every: false }) ? (
                <>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="filter-driver-search-client">
                      <AsyncSelect
                        className="menu-outer-bottom menu-outer-zindex"
                        classNamePrefix="select"
                        cacheOptions
                        defaultOptions
                        isClearable
                        loadOptions={clientLoadOptions}
                        loadingMessage={() => t("React.Select.Wait")}
                        noOptionsMessage={() => t("React.Select.NoOptions")}
                        onChange={e => {
                          if(e === null) {
                            setClientSelectedOption(e);
                            _setDriversSearch(prevState => ({
                              ...prevState,
                              client: JSON.parse(JSON.stringify(ClientSchemaReduced))
                            }));
                          }
                          else {
                            const { dataAux, label, value } = e;
                            setClientSelectedOption({ dataAux, label, value });
                            _setDriversSearch(prevState => ({
                              ...prevState,
                              client: mergeObject(JSON.parse(JSON.stringify(ClientSchemaReduced)), dataAux)
                            }));
                          }
                          setSwitchAllChecked(true);
                          setTimeout(() => {
                            setSwitchAllChecked(false);
                          }, 100);
                        }}
                        placeholder={t("React.Select.SelectClient")}
                        value={clientSelectedOption}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="filter-driver-search-driver">
                      <Form.Control
                        type="text"
                        placeholder={t("Placeholder.Search")}
                        autoComplete={"off"}
                        onChange={e => {
                          e.persist();
                          _setDriversSearch(prevState => ({
                            ...prevState,
                            word: e.target.value
                          }));
                        }}
                        value={_driversSearch.word}
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={12} md={4}>
                    <Form.Group controlId="forms-chassi-active">
                      <Select
                        className="menu-outer-bottom"
                        classNamePrefix="select"
                        options={activeOptions}
                        onChange={e => {
                          if(e === null) {
                            _setDriversSearch(prevState => ({
                              ...prevState,
                              active: -1
                            }));
                          }
                          else {
                            _setDriversSearch(prevState => ({
                              ...prevState,
                              active: e.value
                            }));
                          }
                          setSwitchAllChecked(true);
                          setTimeout(() => {
                            setSwitchAllChecked(false);
                          }, 100);
                        }}
                        value={activeOptions.find(x => x.value === _driversSearch.active)}
                      />
                    </Form.Group>
                  </Col>
                </>
              ) : (
                <Col>
                  <Form.Group controlId="filter-driver-search-driver">
                    <Form.Control
                      type="text"
                      placeholder={t("Placeholder.Search")}
                      autoComplete={"off"}
                      onChange={e => {
                        e.persist();
                        _setDriversSearch(prevState => ({
                          ...prevState,
                          word: e.target.value
                        }));
                      }}
                      value={_driversSearch.word}
                    />
                  </Form.Group>
                </Col>
              )
          }
        </Row>
        <Row>
          <Col>
            <div className="filter-driver-list-all">
              {
                filterMultiple ? (
                  <div className="filter-driver-select-all">
                    <SwitchDefault title={`${t("Title.All")} (${driversSearchQueryEnabled ? driversSearch.length : drivers.length})`} selected={switchAllChecked} onClick={e => {
                      setSwitchSingleChecked(false);
                      setSwitchAllChecked(!switchAllChecked);
                    }} />
                  </div>
                ) : null
              }
              <div className="filter-driver-list-box">
                <ul>
                  {
                    driversSearchQueryEnabled ? (
                      driversSearch.map(driver => {
                        const selected = _driversSelected.find(x => x.id === driver.id) ? true : false;
                        return (
                          <FilterDriverItem
                            key={`filter-driver-list-item-${driver.id}`}
                            checkbox={filterMultiple}
                            name={filterMultiple ? `filter-driver-list-item-${driver.id}` : "filter-driver-list-item"}
                            driver={driver}
                            selected={selected}
                            onClick={e => handleClickDriver(selected, driver)}
                          />
                        );
                      })
                    ) : (
                      drivers.map(driver => {
                        const selected = _driversSelected.find(x => x.id === driver.id) ? true : false;
                        return (
                          <FilterDriverItem
                            key={`filter-driver-list-item-${driver.id}`}
                            checkbox={filterMultiple}
                            name={filterMultiple ? `filter-driver-list-item-${driver.id}` : "filter-driver-list-item"}
                            driver={driver}
                            selected={selected}
                            onClick={e => handleClickDriver(selected, driver)}
                          />
                        );
                      })
                    )
                  }
                </ul>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = state => ({
  props: {
    currentUser: state.users.currentUser,
    drivers: state.drivers.drivers,
    driversSearch: state.drivers.driversSearch,
    driversSearchOnlyClient: state.drivers.driversSearchOnlyClient,
    driversSearchQueryEnabled: state.drivers.driversSearchQueryEnabled
  }
});

const mapDispatchToProps = dispatch => ({
  funcs: bindActionCreators(Object.assign({}, LoadersActions, DriversActions), dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(memo(FilterDriver));
